module.exports = __webpack_public_path__ + "static/media/saturn.34321adf.svg";